import {FlexGridColumnGroup} from '@grapecity/wijmo.react.grid';
import Grid from '@mui/material/Grid';
// import {HttpStatusCode} from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {getFormSyncWarnings, getFormValues, reduxForm} from 'redux-form';
// import {getComboName} from '../../../../common/common.js';
// import {getSessionObject, setSessionObject} from '../../../../common/Session.js';
import {getSessionObject} from '../../../../common/Session.js';
// import {postRequest,
// putRequest
// } from '../../../../../common/backend.js';
// import {GMN, GMN_PATH} from '../../../../../common/commonConst.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {createFieldItems, createGridFields, sysErr} from '../../../../common/commonGmn.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import PaperPart from '../../../atoms/PaperPart.js';
// import PageTitle from '../../../../molecules/PageTitle.js';
// import FooterButton from '../../../organisms/FooterButton.js';
import MainContainer from '../../../organisms/MainContainer.js';
import withRouter from '../../../organisms/withRouter.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import {AutoComplete} from '@grapecity/wijmo.input';
import {DataMap} from '@grapecity/wijmo.grid';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import DangerButton from '../../../atoms/Buttons/DangerButton.js';
// import NegativeButton from '../../../../atoms/Buttons/NegativeButton.js';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import BFY60101G from '../../SCZ/SCZ1012';
import withFormatMessage from '../../../organisms/withFormatMessage.js';
import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import ApprovalComment from '../../../organisms/Approval/ApprovalComment/index.js';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';

// 申請情報Items
const gmnItemsNyuryo = {
  SinseiId: {binding: 'sinseiId', label: '申請番号', required: false, type: 'text', sm: 2, readOnly: true},
  Zigyoujo: {binding: 'zigyoujo', label: 'NW事業所', required: false, type: 'select', sm: 2, variant: 'outlined'},
  userName: {binding: 'userName', label: '作成者', required: false, type: 'text', sm: 2, readOnly: true},
  SakuseiDate: {binding: 'sakuseiDate', label: '作成日', required: false, type: 'date', sm: 2, variant: 'outlined', readOnly: false, blank: true},
  States: {binding: 'states', label: 'ステータス', required: false, type: 'text', sm: 2, readOnly: true},
};

// 承認ステータスItems
const gmnItemsStepApproval = {
  StepApprovalComment: {binding: 'stepApprovalComment', label: '否決コメント', required: false, type: 'text', sm: 6, variant: 'outlined', multiline: true, rows: 3, readOnly: true},
  StepApprovalDateTime: {binding: 'stepApprovalDateTime', label: '否決日', required: false, type: 'text', sm: 2, readOnly: true},
};

// 調査業種管理
const henkomaeViews = [
  {binding: 'zigyoujoBefore', header: '旧NW事業所', type: 'text', width: 130, readOnly: true},
  {binding: 'supplyPointNo', header: '供給地点特定番号', type: 'text', width: 220, readOnly: true},
  {binding: 'customerName', header: 'お客さま名', type: 'text', width: 200, readOnly: true},
  {binding: 'dataCategory', header: '調査・点検データ区分', type: 'text', width: 120, readOnly: true},
  {binding: 'ChousaYearBefore', header: '前回調査年度', required: true, type: 'text', width: 78, sm: 3, readOnly: true},
  {binding: 'TenkenYearBefore', header: '前回点検年度', required: true, type: 'text', width: 78, sm: 3, readOnly: true},
  {binding: 'researchCompanyCode', header: '委託エリア', required: true, type: 'Select', width: 120, sm: 3, readOnly: false},
  {binding: 'chousaKikan', header: '調査会社', required: true, type: 'text', width: 120, sm: 3, readOnly: true},
  {binding: 'blockBango', header: 'ブロック番号', type: 'text', width: 100, readOnly: true},
  {binding: 'bikou', header: '備考', type: 'text', width: 300, readOnly: false},
];

/**
 * 調査・点検箇所追加交付登録
 * 画面ID:SCD1003
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    // 調査管理区分
    let researchCompanyCode = [
      {id: '0', name: '中電NWC'},
      {id: '1', name: '委託１'},
      {id: '2', name: '委託２'},
      {id: '3', name: '委託３'},
    ];
    // 調査業種
    let chousaGyousyuCode = [
      {id: '02', name: '寝たきり'},
      {id: '03', name: 'プール'},
      {id: '04', name: '浴場'},
      {id: '05', name: '学校等'},
      {id: '06', name: '病院等'},
      {id: '07', name: '老人福祉'},
      {id: '08', name: '重要文化財'},
      {id: '09', name: '学校でかつプール施設'},
    ];
    // 調査理由
    let chousaRiyuuCode = [
      {id: '12', name: '漏えい電流が1mA超過で未調査'},
      {id: '13', name: '漏えい電流の測定不能'},
      {id: '99', name: '調査理由の取消'},
    ];
    // パラメータ取得
    const storage = getSessionObject(GMN.TSTK_KASYO_MANAGE_INFO.id);
    const _list = [
      {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
      {gmnName: GMN.TSTK_KASYO_MANAGE_LIST.name, href: GMN_PATH.TSTK_KASYO_MANAGE_LIST},
      {gmnName: GMN.TSTK_KASYO_MANAGE_INFO.name, href: ''},
    ];
    // TODO フロント画面の判定条件
    let mode = 0;
    let visableSnFlg = true;
    let visableSlFlg = true;
    if (storage['mod'] === 'I') {
      mode = 0;
      visableSnFlg = false;
    } else if (storage['mod'] === 'C') {
      mode = 1;
      visableSnFlg = false;
    } else if (storage['mod'] === 'S') {
      mode = 2;
      visableSnFlg = false;
    } else if (storage['mod'] === 'U') {
      mode = 3;
      visableSnFlg = true;
    } else {
      mode = 4;
      visableSnFlg = false;
    }
    visableSlFlg=storage['hiKetuFlag'];

    this.state = {
      // 1:請求書再請求 2:承認フロー
      mode: mode,
      warningMessages: [],
      // 請求情報
      seikyuInfo: storage ?? {},
      transitionList: _list,
      henkoJohomaeList: [],
      seiHeaderDate: {},
      researchCompanyList: researchCompanyCode,
      chousaGyousyuList: chousaGyousyuCode,
      chousaRiyuuList: chousaRiyuuCode,
      // 承認機能部表示判定条件
      visableSnFlg: visableSnFlg,
      visableSlFlg: visableSlFlg,
      buttonDisabled: true,
      listZigyojoMst: [],
      modalOpen: false,
      gamenData: {},
      gridRefErr: false,
      showApprovalModal: false,
    };
    // 一覧Ref作成
    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.getInitializeData();
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let initItems = {};
    this.initializeItems(initItems);
    let henkoJohomaeList = [];
    let data = {};

    if (this.state.mode !== 0) {
      henkoJohomaeList = [
        {zigyoujoBefore: '広島北NWC', supplyPointNo: '01 2345 6789 0123 4567 8901', blockBango: '00001', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '1', chousaKikan: '保安協会', dataCategory: '調査・点検対象', customerName: '田中小学校１', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '広島北NWC', supplyPointNo: '01 2345 6789 0123 4567 8902', blockBango: '00002', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '2', chousaKikan: '工業組合', dataCategory: '調査対象', customerName: '田中小学校２', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '廿日市NWC', supplyPointNo: '01 2345 6789 0123 4567 8903', blockBango: '00004', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '1', chousaKikan: '保安協会', dataCategory: '調査対象', customerName: '田中小学校３', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '廿日市NWC', supplyPointNo: '01 2345 6789 0123 4567 8904', blockBango: '00005', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '1', chousaKikan: '保安協会', dataCategory: '調査対象', customerName: '田中小学校４', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '広島北NWC', supplyPointNo: '01 2345 6789 0123 4567 8905', blockBango: '00006', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '0', chousaKikan: '中電ＮＷ', dataCategory: '調査対象', customerName: '田中小学校５', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '廿日市NWC', supplyPointNo: '01 2345 6789 0123 4567 8906', blockBango: '00007', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '0', chousaKikan: '中電ＮＷ', dataCategory: '調査対象', customerName: '田中小学校６', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '広島北NWC', supplyPointNo: '01 2345 6789 0123 4567 8907', blockBango: '00008', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '1', chousaKikan: '保安協会', dataCategory: '調査対象', customerName: '田中小学校７', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '廿日市NWC', supplyPointNo: '01 2345 6789 0123 4567 8908', blockBango: '00009', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '1', chousaKikan: '保安協会', dataCategory: '調査対象', customerName: '田中小学校８', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '広島北NWC', supplyPointNo: '01 2345 6789 0123 4567 8909', blockBango: '00010', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '3', chousaKikan: '工業組合', dataCategory: '調査対象', customerName: '田中小学校９', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '広島北NWC', supplyPointNo: '01 2345 6789 0123 4567 8910', blockBango: '00011', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '3', chousaKikan: '工業組合', dataCategory: '調査対象', customerName: '田中小学校１０', bikou: '調査・点検対象漏れ、追加'},
        {zigyoujoBefore: '広島北NWC', supplyPointNo: '01 2345 6789 0123 4567 8911', blockBango: '00012', ChousaYearBefore: '2024', TenkenYearBefore: '2024', researchCompanyCode: '3', chousaKikan: '工業組合', dataCategory: '調査対象', customerName: '田中小学校１１', bikou: '調査・点検対象漏れ、追加'},
      ];
      if (this.state.mode === 1) {
        data = {sinseiId: '51602025031401', zigyoujo: '5160', sakuseiDate: '2025-03-14', states: '作成中', userName: '田中　さくら'};
      } else if (this.state.mode === 2) {
        data = {sinseiId: '51602025032101', zigyoujo: '5160', sakuseiDate: '2025-03-21', states: '取止済', userName: '田中　さくら'};
      } else if (this.state.mode === 3) {
        data = {sinseiId: '51602025031801', zigyoujo: '5160', sakuseiDate: '2025-03-18', states: '承認中', userName: '田中　さくら'};
      } else {
        data = {sinseiId: '51602025032001', zigyoujo: '5160', sakuseiDate: '2025-03-20', states: '完了', userName: '田中　さくら'};
      }
    } else {
      data = {sinseiId: '', zigyoujo: '5160', sakuseiDate: '2025-03-28', states: '作成中', userName: '田中　さくら'};
    }

    // 調査業種登録情報データ設定
    for (const key of Object.keys(initItems)) {
      if (Object.hasOwn(data, key)) {
        initItems[key] = data[key];
      }
    }

    initItems['approvalComment'] = 'approvalComment';

    // 調査業種登録情報データを画面に設定
    this.props.doSetInitValues(initItems);

    if (this.gridRef.current) {
      // 変更前リストデータを画面に設定
      this.gridRef.current.setItemsSource(henkoJohomaeList);
    }

    let listZigyojoMst = [];
    let listMumber1 =
        {id: '1', cd: '5160', cdName: '広島北NWC'};
    listZigyojoMst.push(listMumber1);
    let listMumber2 =
        {id: '2', cd: '6120', cdName: '山口NWC'};
    listZigyojoMst.push(listMumber2);

    this.setState({
      // henkoJohomaeList: henkoJohomaeList,
      seiHeaderDate: data,
      listZigyojoMst: listZigyojoMst,
    });
    // } else {
    //   sysErr(this.props);
    // }
  };

  /**
   * 画面項目初期化
   * @param {object} initItems
   */
  initializeItems = (initItems) => {
    const gmnItems = Object.assign(
        gmnItemsNyuryo,
    );
    for (const key of Object.keys(gmnItems)) {
      const item = gmnItems[key];
      if (Object.hasOwn(item, 'binding')) {
        initItems[item.binding] = null;
      }
    }
  };

  /**
   * コンボリスト作成
   * @param {array} itemsList
   * @param {string} label
   * @param {array} comboList
   */
  setComboList = (itemsList, label, comboList) => {
    const index = this.findIndex(itemsList, label);
    if (index !== -1) {
      itemsList[index].selections = comboList;
    }
  };

  /**
   * 配列検索
   * @param {array} list
   * @param {string} label
   * @return {number} インデックス
   */
  findIndex = (list, label) => {
    return list.findIndex((element) => {
      return element.label === label;
    });
  };

  /**
   * 登録
   */
  doCreate = async () => {
  };

  /**
   * 取下げ
   */
  doWithdraw = async () => {
  };

  /**
   * 操作ボタン生成
   * @return {*}
   */
  createBtnProps() {
    const {handleSubmit} = this.props;

    let btnProps = [];
    const btnCreate = {type: 'positive', key: 'SCA1002Create', label: '行追加', click: handleSubmit(this.doCreate)};
    const btnWithdraw = {type: 'positive', key: 'SCA1002Withdraw', label: '行削除', click: handleSubmit(this.doWithdraw)};

    btnProps.push(btnCreate, btnWithdraw);


    return btnProps;
  }

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 一覧パーツ取得 委託エリア
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getComboResearchCompanyList = (view, readOnly) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(this.state.researchCompanyList, 'id', 'name')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: this.state.researchCompanyList,
        selectedValuePath: 'id',
        displayMemberPath: 'name',
      })}
      isReadOnly={readOnly}/>;
  };

  /**
   * 一覧パーツ取得 調査業種
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getComboChousaGyousyuList = (view, readOnly) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(this.state.chousaGyousyuList, 'id', 'name')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: this.state.chousaGyousyuList,
        selectedValuePath: 'id',
        displayMemberPath: 'name',
      })}
      isReadOnly={readOnly}/>;
  };

  /**
   * 一覧パーツ取得 調査理由
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getComboChousaRiyuuList = (view, readOnly) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(this.state.chousaRiyuuList, 'id', 'name')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: this.state.chousaRiyuuList,
        selectedValuePath: 'id',
        displayMemberPath: 'name',
      })}
      isReadOnly={readOnly}/>;
  };

  /**
   * 変更前一覧描画
   * @return {*}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'check',
      id: 'SCA1002HenkomaeTable',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'Columns',
      // style: {height: 'auto', maxHeight: '300px', width: 'auto', maxWidth: '100%', marginTop: '0px'},
      isReadOnly: false,
      screenId: 'SCA1002Henkomae',
      checkedFunction: this.checkStateUpdate,
      doShowMessage: this.props.doShowMessage,
      validateEdits: false,
      DeleteOn: true,
      isDisplayCount: true,
      getError: this.getError,
    };
    // 一覧定義取得
    let viewElems = [];
    if (henkomaeViews) {
      for (const view of henkomaeViews) {
        let viewElem;
        if (view.type === 'Select') {
          switch (view.binding) {
            case 'researchCompanyCode':
              viewElem = this.getComboResearchCompanyList(view, false);
              break;
            case 'chousaGyousyu':
              viewElem = this.getComboChousaGyousyuList(view, false);
              break;
            case 'chousaRiyuu':
              viewElem = this.getComboChousaRiyuuList(view, false);
              break;
            default:
              viewElem = this.getComboResearchCompanyList(view, false);
          }
          // viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 調査業種登録一覧画面の入力チェック
   * @param {object} item 検証行データ
   * @param {string} prop binding
   * @param {boolean} parsing 予期されたデータ型に解析できない値を入力したかどうか
   * @return {string} 結果
   */
  getError = (item, prop, parsing) => {
    if (parsing) {
      return null;
    }
    if (prop == 'henkoGo' && item.henkoGo == '') {
      return this.props.getMessage('BFY000017E', ['変更後', item.rowId + '行目']);
    }
    if (prop == 'jikai' && item.jikai == '') {
      return this.props.getMessage('BFY000017E', ['次回', item.rowId + '行目']);
    }
  };

  /**
   * 一覧に変更があるかチェックする
   * @return {bool} true: 変更あり
   */
  doCheckModified = () => {
    let result = false;
    if (this.gridRef.current) {
      result = this.gridRef.current.commitAndCheck();
    }
    return result;
  };

  // /**
  //  * リンクの別タブで画面遷移
  //  * @param  {*} e
  //  */
  // handleLinkClick = (e) => {
  //   e.preventDefault();
  //   const _data = this.state.seikyuInfo;
  //   // BFE10101G_請求一覧に遷移
  //   setSessionObject(
  //       GMN.BFE10101G.id,
  //       this.setParam('', _data),
  //   );
  //   window.open('/BFE10101G', '_blank');
  // };

  /**
   * パラメータ設定
   * @param {*} list パラメータリスト
   * @param {*} data データ
   * @return {*} パラメータ
   */
  setParam = (list, data) =>{
    let _param = {};
    list.forEach((key) => {
      if (Object.hasOwn(data, key)) {
        _param[key] = data[key];
      }
    });
    return _param;
  };

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.doSetInitValues(null);
  }

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
          this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        // action: () => {
        //   this.props.history.push('/login');
        // },
      });
    }
  };

  /**
   * 取消ボタン押下時
   */
  doDelete = () => {
    let _warningMessages = null;
    try {
      if (!this.gridRef ||
      !this.gridRef.current) {
        return;
      }
      // 未選択チェック
      const count = this.gridRef.current.selectedItemCount();
      if (count === 0) {
        this.props.doShowMessage({
          message: {
            id: 'BFY000023E',
            values: ['取消'],
          },
        });
        return;
      }
      const items = this.gridRef.current.selectedItem();
      let cv = this.gridRef.current.grid.collectionView;
      cv.beginUpdate();
      // 削除
      for (let rowIndex = count - 1; rowIndex >= 0; rowIndex --) {
        let removeIndex = items[rowIndex].index;
        cv.removeAt(removeIndex);
      }
      cv.endUpdate();
    } catch (error) {
      // sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  doInterimSave = () => {
    let values = this.props.values;
    let _warningMessages = [];
    this.setState({
      warningMessages: _warningMessages,
    });

    if (values.sinseiId == '') {
      let message = {
        id: 'BFY000017E',
        values: ['申請番号', ''],
      };
      _warningMessages.push(message);
    }
    if (values.zigyoujo == '') {
      let message = {
        id: 'BFY000017E',
        values: ['NW事業所', ''],
      };
      _warningMessages.push(message);
    }
    if (values.sakuseiDate == '') {
      let message = {
        id: 'BFY000017E',
        values: ['作成日', ''],
      };
      _warningMessages.push(message);
    }

    let tebleData = this.gridRef.current.grid.rows.length;
    for (let i = 0; i < tebleData; i++ ) {
      let a = this.gridRef.current.grid.rows[i].dataItem;
      if (a.henkoGo == '') {
        let message = {
          id: 'BFY000017E',
          values: ['変更後', a.rowId + '行目'],
        };
        _warningMessages.push(message);
      }
      if (a.jikai == '') {
        let message = {
          id: 'BFY000017E',
          values: ['次回', a.rowId + '行目'],
        };
        _warningMessages.push(message);
      }
    }

    if (_warningMessages.length > 0) {
      this.setState({
        warningMessages: _warningMessages,
      });
      return;
    } else {
      this.props.doShowMessage({
        message: {
          id: 'BFY000009I',
          values: ['一時保存'],
        },
      });
    }
  };

  doSyoninShinsei = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認申請'],
      },
    });
  };

  doFullDelete = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['取消'],
      },
    });
  };


  /**
   * 承認ダイアログの表示
   * @param {string} type
   */
  displayApprovalComment = (type) => {
    this.setState({
      showApprovalCommentModal: true,
      approvalType: type,
    });
  };

  /**
 * 承認ダイアログを閉じる
 */
  closeApprovalComment = () => {
    this.setState({
      showApprovalCommentModal: false,
    });
  };

  /**
   * 追加ボタン押下時
   */
  doAdd = () => {
    let data = this.props.values;
    this.setState({modalOpen: true, gamenData: data});
  };

  doClose = () => {
    // 請求情報データを画面に設定
    let data = this.state.gamenData;
    this.props.doSetInitValues(data);
    this.setState({modalOpen: false});
  };

  /**
   * 共通表示内容の取得
   * @param {*} items
   */
  getSelectItems = (items) => {
    let selectItems = items;
    console.log(selectItems);
    let tebleData = this.gridRef.current.grid.rows.length;
    let tebleData2 = selectItems.length;
    let list = [];
    let c = 0;
    for (let i = 0; i < tebleData; i++ ) {
      let a = this.gridRef.current.grid.rows[i].dataItem;
      list.push(a);
      if (c < parseInt(a.blockBango)) {
        c = parseInt(a.blockBango);
      }
    }
    for (let i = 0; i < tebleData2; i++ ) {
      let b = {blockBango: '000' + (c + 1 + i), supplyPointNo: '01 2345 6789 0123 4567 8901', customerName: '追加会社', researchCompanyCode: '3：委託２', chousaGyousyu: '05：学校等', chousaYearAfter: '2026', chousaRiyuu: '12:漏えい電流が1mA超過で未調査'};
      list.push(b);
    }
    this.gridRef.current.setItemsSource(list);
    let data = this.state.gamenData;
    this.props.doSetInitValues(data);
    this.setState({modalOpen: false});
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {/* <Grid key="key1001Back" item>
          <BackButton props={this.props}/>
        </Grid> */}
        {/* <Grid key="key1001LineAdd" item>
          <PositiveButton
            id="btn1001LineAdd"
            // onClick={handleSubmit(this.doTenNext)}
            onClick={this.doAdd}
            variant="contained"
            startIcon={<AddIcon />}
            // size="large"
          >
            <span>行追加</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001LineDelete" item>
          <DangerButton
            id="btn1001LineDelete"
            // onClick={handleSubmit(this.doTenNext)}
            onClick={this.doDelete}
            variant="contained"
            startIcon={<DeleteIcon />}
            disabled={this.state.buttonDisabled}
            // size="large"
          >
            <span>行削除</span>
          </DangerButton>
        </Grid> */}
        <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={this.doInterimSave}
            variant="contained"
            startIcon={<SaveAltIcon />}
            // size="large"
          >
            <span>一時保存</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen2" item>
          <DangerButton
            id="btn1001CreateTen2"
            onClick={this.doFullDelete}
            variant="contained"
            startIcon={<Cancel />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>取消</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </DangerButton>
        </Grid>
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            startIcon={<SaveIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>承認申請</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        {this.state.visableSnFlg &&
        <Grid key="approvalButton" item>
          <PositiveButton
            id="approvalButton"
            onClick={()=> {
              this.displayApprovalComment('1');
            }}
            variant="contained"
            startIcon={<CheckCircle />}
          >
            <span>承認</span>
          </PositiveButton>
        </Grid>}
        {this.state.visableSnFlg &&
        <Grid key="rejectButton" item>
          <DangerButton
            id="rejectButton"
            onClick={()=> {
              this.displayApprovalComment('2');
            }}
            variant="contained"
            startIcon={<Cancel />}
          >
            <span>否決</span>
          </DangerButton>
        </Grid>}
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.displayApproval}
            variant="contained"
            // startIcon={<SaveIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>承認状況</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
      </Grid>

    );
  };

  /**
   * 承認状況画面の表示
   */
  displayApproval = () => {
    this.setState({
      showApprovalModal: true,
    });
  };

  /**
   * 承認状況画面画面を閉じる
   */
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
    });
  };

  /**
   * 画面描画
   * @return {*}
   */
  render() {
    const {userInfo} = this.props;
    let itemListNyuryo = createFieldItems(gmnItemsNyuryo);
    let itemListStepApproval = createFieldItems(gmnItemsStepApproval);
    this.setComboList(itemListNyuryo, 'NW事業所', this.state.listZigyojoMst);
    // // ボタン
    // const _btnProps = this.createBtnProps();

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    return (
      <form noValidate autoComplete="off" className="form_root">
        <MainContainer
          props={this.props}
          ActorName={userInfo.ActorName}
          footerBtn={footerBtn}
        >
          <Grid key="keySCA1002Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={this.state.transitionList}/>
          <Grid key="keySCA1002OrderGrid" item xs={12}>
            <PaperPart>
              {createGridFields(GMN.TSTK_KASYO_MANAGE_INFO.id,
                  itemListNyuryo)}
            </PaperPart>
            {this.state.visableSlFlg &&
            <span>
              <PaperPart>
                <Typography variant="h6" gutterBottom>否決</Typography>
                {createGridFields(GMN.TSTK_KASYO_MANAGE_INFO.id,
                    itemListStepApproval)}
              </PaperPart>
            </span>
            }
            <div style={{marginBottom: '20px'}} />
            <Divider variant="middle" />
            <div style={{marginBottom: '4px'}} />
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Grid key="keySCA1002HenkomaeTable" item xs={12}>
                {this.renderTable()}
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
              direction={'row'}
            >
              <Grid key="key1001LineAdd" item>
                <PositiveButton
                  id="btn1001LineAdd"
                  // onClick={handleSubmit(this.doTenNext)}
                  onClick={this.doAdd}
                  variant="contained"
                  startIcon={<AddIcon />}
                  // size="large"
                >
                  <span>行追加</span>
                </PositiveButton>
              </Grid>
              <Grid key="key1001LineDelete" item>
                <DangerButton
                  id="btn1001LineDelete"
                  // onClick={handleSubmit(this.doTenNext)}
                  onClick={this.doDelete}
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  disabled={this.state.buttonDisabled}
                  // size="large"
                >
                  <span>行削除</span>
                </DangerButton>
              </Grid>
            </Grid>
          </Grid>

        </MainContainer>
        <BFY60101G
          modalOpen={this.state.modalOpen}
          closeButton={this.doClose}
          selectButton={this.getSelectItems}></BFY60101G>
        <ApprovalComment
          openState={this.state.showApprovalCommentModal}
          tstk={false}
          approvalType={this.state.approvalType}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApprovalComment}/>
        <ApprovalStatus
          openState={this.state.showApprovalModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApproval}/>
      </form>
    );
  }
}

const FORM_NAME = 'SCA1002FORM';
Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    syncWarnings: getFormSyncWarnings(FORM_NAME)(state),
  };
})(Container));

Container.propTypes = {
  userInfo: PropTypes.object,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  title: PropTypes.string,
  genericMap: PropTypes.object,
  getMessage: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
    genericMap: state.common.generalPurposeMap,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withFormatMessage(withMediaQuery()(Container))));
